<template>
  <div class="ly-table">
    <div class="ly-title">
      <h3 class="title-table"><slot></slot></h3>
      <div class="table-toggle" v-if="toggle === true">
        <i class="el-icon-arrow-up" @click="clickToggle"></i>
      </div>
    </div>
    <div ref="content">
      <div class="content-datail">
        <div class="tab-table">
          <div class="ly-detail-content">
            <div class="flex-detail">
              <div class="ly-sort ly-sort-his">
                <span class="count"> [본작업] </span>
              </div>

              <idc-no-data-nc style="height: 257px" />
            </div>
            <div class="flex-detail">
              <div class="ly-sort ly-sort-his">
                <span class="count"> [작업 전/후 확인 및 원복작업] </span>
              </div>

              <idc-no-data-nc-co style="height: 257px" />
            </div>
          </div>
          <div class="btn-box" v-if="!$isMobile()">
            <el-button plain type="save" v-if="isWrite" :disabled="isTemplate"
              >INCOA 작업요청</el-button
            >
            <el-button plain type="save" v-if="isWrite" :disabled="isTemplate"
              >INCOA 링크</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <el-divider class="wrk-comp-divider" v-if="!toggleData"></el-divider>
  </div>
</template>
<script>
// 22.03.14 작업관리 NW작업 INCOA 추가
import IdcNoData from "@/components/common/IdcNoData.vue";
import IdcNoDataNc from "@/components/common/IdcNoDataNc.vue";
import IdcNoDataNcCo from "@/components/common/IdcNoDataNcCo.vue";
export default {
  components: {
    IdcNoData,
    IdcNoDataNc,
    IdcNoDataNcCo,
  },
  props: {
    openToggle: {
      value: Boolean,
      default: false,
    },
    innerAst: {
      value: Array,
    },
    type: {
      value: String,
      default: "",
    },
    defaultValue: {
      type: Object,
      default: () => {},
    },
    isWrite: {
      type: Boolean,
      default: true,
    },
    isTemplate: {
      type: Boolean,
      default: true,
    },
    assetTypeCd: {
      type: String,
      default: "",
    },
    prcssTrtDataCnctId: {
      type: String,
      default: "",
    },
    exeWflowId: {
      type: String,
      default: "",
    },
    idcCd: {
      type: String,
      default: "",
    },
    ticketInfo: {
      type: Object,
      default: () => {},
    },
    //상위 공정 ID
    mainPrcssId: {
      type: String,
      default: "",
    },
    //하위 공정 ID
    subPrcssId: {
      type: String,
      default: "",
    },
    scrnId: {
      type: String,
      default: "",
    },
    wflowScrnId: {
      type: String,
      default: "",
    },
    scrnGetApi: {
      type: String,
      default: "",
    },
    scrnPostApi: {
      type: String,
      default: "",
    },
    scrnPutApi: {
      type: String,
      default: "",
    },
    scrnDeleteApi: {
      type: String,
      default: "",
    },
    mandDataChkYn: {
      type: String,
      default: "N",
    },
    sftyChkMandChkYn: {
      type: String,
      default: "N",
    },
    sftyChkScrnYn: {
      type: String,
      default: "N",
    },
    callDate: {
      type: Number,
      default: -1,
    },
    stepCd: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      dialogRack: false,
      toggleData: true,
      toggle: this.openToggle,
      value: "",
      incoaData: "",
    };
  },
  mounted() {
    this.incoaData = "incoa config \n 데이터 데이터";
  },
  methods: {
    clickToggle(e) {
      if (this.toggleData) {
        this.$refs.content.style = "display: none";
        e.target.className = "el-icon-arrow-down";
      } else {
        this.$refs.content.style = "display: block;";
        e.target.className = "el-icon-arrow-up";
      }
      this.toggleData = this.toggleData ? false : true;
    }, 
    getTemplateData() {
      // 상위 컴포넌트에서 호출
      // Axios로 저장 시 넘겨줄 데이터를 리턴하면 됨.
      return "";
    },
    chkValidateData() {
      return true;
    }
  }
};
</script>
<style lang="scss" scoped>
.el-button + .el-button {
  margin-left: 3px;
}
.btn-box {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}
.ly {
  &-sort {
    margin-top: 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    &-his {
      padding: 0 0 8px 0;
    }
  }
  &-detail {
    &-top {
      padding-bottom: 0px;
    }
    &-content {
      padding: 0;
      display: flex;
      justify-content: space-between;
      gap: 10px;
      .flex-detail {
        width: 50%;
        .ly-sort-his {
          padding-top: 0;
        }
      }
    }
  }

  &-table {
    // padding-top: 0;
  }
}
.tableOptions {
  display: flex;
  justify-content: flex-end;
  width: 100%;
}
::v-deep {
  @include mobile {
    .tab-table {
      margin-top: 0 !important;
    }
  }
}
</style>
